import { render, staticRenderFns } from "./HutangUsaha.vue?vue&type=template&id=04bd1fc6"
import script from "./HutangUsaha.vue?vue&type=script&lang=js"
export * from "./HutangUsaha.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports